module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "titg"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "navy"
  }, [_vm._v("super")])]), _vm._v(" "), _c('h1', {
    staticClass: "title1"
  }, [_c('span', {
    staticClass: "white"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("simple")]), _vm._v(" quilts")])]), _vm._v(" "), _c('div', {
    staticClass: "tit"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v("#"), _c('span', {
    staticClass: "fontw"
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('span', {
    staticClass: "smallw"
  }, [_vm._v("WITH")]), _vm._v(" ALEX ANDERSON & LIZ ANELOSKI")])]), _vm._v(" "), _c('div', {
    staticClass: "titb"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("9 Pieced Projects from Strips, Squares & Triangles")])]), _vm._v(" "), _c('div', {
    staticClass: "titg1"
  }, [_c('div', {
    staticClass: "img_containerz"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0001-01.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_containerz1"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pub.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d14a958","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/01_Title.vue
// module id = 60
// module chunks = 0